<ngx-spinner></ngx-spinner>

<div *ngIf="isTokenValidated || isErrorDetected">
  <header>
    <div class="header-container">
      <div class="logo-service-box">
        <img src="assets/logo.png" alt="Logo" class="logo-icon" />
      </div>
      <div class="header-title">
        <span class="brand-care-title">{{ brandCareTitle }}</span>
      </div>
    </div>
  </header>
  <div class="main-container">
    <!-- CAP-39922 DMBR-64 New Submission History Change -->
    <div
      class="vehicle-info-box d-flex align-items-center"
      *ngIf="showVehicleInfo"
    >
      <app-vehicle-info
        *ngIf="!isErrorDetected && isTokenValidated"
        [vehicleInfo]="selectedVehicleInfo"
        [loading]="searchingVin"
      ></app-vehicle-info>
    </div>

    <!-- Show critical error message below vehicle info if error detected -->
    <app-status-message
      *ngIf="isErrorDetected && !isTokenValidated"
      style="background-color: #eff1f3"
      [type]="'error'"
      [title]="'dimbo.i18n.error.critical'"
      [message]="errorMessage"
    >
    </app-status-message>

    <!-- Error Page-->
    <app-status-message
      style="background-color: #edeff159"
      *ngIf="showStatusMessage && isTokenValidated"
      [type]="statusType"
      [message]="statusMessage"
    >
    </app-status-message>

    <div *ngIf="!showStatusMessage">
      <div
        class="d-flex justify-content-between pl-5 pr-4 pt-3"
        style="background-color: #eff1f3"
      >
        <mat-tab-group
          [selectedIndex]="selectedTab"
          (selectedTabChange)="selectTab($event)"
        >
          <mat-tab *ngFor="let tab of tabs" [label]="tab"></mat-tab>
        </mat-tab-group>

        <!-- Use this in root.component.html or history.component.html -->

      </div>


      <div class="tab-content-scroll-area">
        <div class="tab-content">
          <!-- CAP-39922 DMBR-64 New Submission History Change -->
          <ng-container [ngSwitch]="tabs[selectedTab]">
            <app-allurecare-form
              *ngSwitchCase="mTab"
              (statusMessage)="onStatusMessage($event)"
            >
            </app-allurecare-form>

            <ng-container *ngSwitchCase="shTab">
              <!-- Old history: Authorized Repairer with submissionMode = true -->
              <app-history
                *ngIf="!showNewSubmissionHistory"
                [errorMessage]="vinSearchErrorMessage"
                [searchResults]="vinSearchResults"
                [loading]="searchingVin"
                [isVinSearch]="true"
                [submissionMode]="submissionMode"
                [isCentralUser]="isCentralUser"
                (vehicleInfoChange)="handleVehicleInfoChange($event)"
              >
              </app-history>

              <!-- CAP-39922 DMBR-64 New Submission History Change -->
              <app-submission-history *ngIf="showNewSubmissionHistory"
                [submissionMode]="submissionMode"
                [defaultVin]="defaultVin"
                [isCentralUser]="isCentralUser"
                (vinSearchPerformed)="onSubmissionHistoryVinSearch($event)"
                (vinSearchCompleted)="onVinSearchCompleted($event)">
              </app-submission-history>
              <!-- End of CAP-39922 DMBR-64 Change -->
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
